import React from 'react';
import PropTypes from 'prop-types';
import ListItemContent from './ListItemContent';

class List extends React.Component {
  constructor(props) {
    super(props);
    this.highlightBox = this.highlightBox.bind(this);
    this.restoreForm = this.restoreForm.bind(this);

    this.state = {
      highlightedBox: '',
    };
  }

  highlightBox(box) {
    if (this.props.shouldHighlight) {
      this.props.updateBackgroundImage(box);

      this.setState({
        highlightedBox: box,
      });
    }
  }

  restoreForm() {
    if (this.props.shouldHighlight) {
      this.props.updateBackgroundImage('');

      this.setState({
        highlightedBox: '',
      });
    }
  }

  render() {
    const {
      documentName,
      items,
      showThumbnail,
    } = this.props;
    return (
      <ul className="help-side-bar-list">
        {items.map((item) => {
          const thumbnailUrl = `/images/builder-static/${documentName}-highlighted-boxes/box-${item.box}.png`;
          const thumbnail = documentName && showThumbnail ? thumbnailUrl : '';
          return (
            <li
              key={`item-${item.title}`}
              onMouseEnter={() => (this.highlightBox(item.box))}
              onMouseLeave={this.restoreForm}
            >
              <ListItemContent
                box={item.box}
                details={item.details}
                isHighlighted={this.state.highlightedBox === item.box}
                thumbnail={thumbnail}
                title={item.title}
              />
            </li>
          );
        })
        }
      </ul>
    );
  }
}

List.defaultProps = {
  documentName: '',
  items: [],
  shouldHighlight: false,
  showThumbnail: false,
  updateBackgroundImage: null,
};

List.propTypes = {
  documentName: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      box: PropTypes.string,
      details: PropTypes.arrayOf(PropTypes.string),
      keywords: PropTypes.arrayOf(PropTypes.string),
      title: PropTypes.string,
    }),
  ),
  shouldHighlight: PropTypes.bool,
  showThumbnail: PropTypes.bool,
  updateBackgroundImage: PropTypes.func,
};

export default List;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/components/List.jsx